// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { LMFieldBaseComponent, LMInvalidFieldEvent } from '@field/lm-field-base.component';
import { trim } from 'lodash-es';
import { isEmpty } from 'lodash-es';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import { LMModelChangedEvent } from '@form/model';
import { LMFormPersonalization, LMFormState } from '@app/states';
import { ExpandableAreaComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-header',
  templateUrl: './lm-header.component.html',
  styleUrls: [ './lm-header.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMHeaderComponent extends LMFieldBaseComponent implements OnInit {
  @Input() layoutObject: LMFormLayoutHeaderUI;

  // Optional info for collapsible header
  @Input() formSpec;
  @Input() formOptions: LMFormOptions = null;
  @Input() formState: LMFormState;
  @Input() formPersonalization: LMFormPersonalization;
  @Input() activatedTabChanged: boolean;
  @Input() parentIsModal: boolean;
  @Input() specFields: LMSpecFields;
  @Input() previousSiblingIsCollapsible = false;

  @ViewChild(ExpandableAreaComponent) expandableArea: ExpandableAreaComponent;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  public header: LMFormLayoutHeaderUI;
  public title: string;
  public titleIsEmpty = false;

  public collapsed = false;
  public buttonIcon: string;
  public headerError = false;
  public collapsibleOnSearch = false;
  public collapsibleOnLeftSearch = false;
  public useShowMore = false;

  private open = true;

  constructor( protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFieldServiceAdapter);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);
    this.header = this.layoutObject;

    this.fieldAutomationId = this.uniqueFieldAutomationId(this.header.automationId);

    if (this.header.textStyle.align === 'left' && Soho.Locale.isRTL()) {
      this.header.textStyle.align = 'right';
    }
    this.size = this.header.size || 3;

    if (this.header.collapsible) {
      this.collapsed = this.header.isInitiallyCollapsed;
      this.open = !this.collapsed;
      this.setIcon();
    }

    this.collapsibleOnSearch = this.model.isSearchForm && this.header.collapsible;
    this.collapsibleOnLeftSearch = this.collapsibleOnSearch && this.model.formSpec.showSearchFormOnLeft;
    this.useShowMore = this.header.useShowMore;

    // first time
    this.updateHeaderValue();

    this.subscriptionArray.push(this.model.modelChanged
      .subscribe((modelChangedEvent: LMModelChangedEvent) => {
        if (modelChangedEvent.eventType === 'set') {
          this.updateHeaderValue();
        }
      })
    );

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
  }

  setIcon() {
    if (this.open) {
      this.buttonIcon = 'chevron-up';
    } else {
      this.buttonIcon = 'chevron-down';
    }
  }

  private updateHeaderValue() {
    if (this.header.title) {
      this.title = this.header.title as string;
    } else if (this.header.header) {
      this.title = this.lmFieldServiceAdapter.lmFormatUtilService.formatMessageRule(this.header.header as LMMessageRule, this.model, this.specFields);
    }

    this.titleIsEmpty = (isEmpty(trim(this.title)));
  }

  onClick($event: MouseEvent, fromTemplate?: boolean) {
    if (this.header.collapsible && fromTemplate) {
      $event.stopPropagation();
      $event.stopImmediatePropagation();
      if (this.expandableArea) {
        if (this.open) {
          this.expandableArea.close();
          this.open = false;
        } else {
          this.expandableArea.open();
          this.open = true;
        }
        this.setIcon();
      }
    }
  }

  onFieldEvent(event) {
    // check if the field is in error, and open the collapsed header if it is
    if (event instanceof LMInvalidFieldEvent) {
      this.expandableArea.open();
      this.open = true;
      this.headerError = true;
      this.setIcon();
    }
    super.onFieldEvent(event);
  }
}
